import {
    apiRegister
} from '../../common/api';

import {
    isNumber,
    isPlain,
    isString
} from '../../common/utils';
import { KGame } from '../../models/kgame';
import { ERR_REP_GAME_INFO, ERR_REQ_GAME_ID } from '../../common/const';

function checkResult({
    gameInfo
}) {
    if (!isPlain(gameInfo) || !isNumber(gameInfo.gameId)) {
        return ERR_REP_GAME_INFO // 数据格式非法
    }
    return 0
}

function formatResult({
    gameInfo
}) {
    // 格式化
    // console.log(gameInfo.actionList);
    gameInfo = KGame(gameInfo)
    // console.log(gameInfo.actionList);
    // console.log(gameInfo);
    // let actionList = prop(gameInfo, 'actionList')
    // if(isArray(actionList)) {
    //     actionList = filter(actionList, o => !!o && o.kid > 0)
    // } else {
    //     actionList = []
    // }
    // gameInfo.actionList = actionList
    return gameInfo
}

/*
协议Id 
888
项目 
模块 
方式 
https 
命令（路径） 
/award/reality/gameinfo/
说明
实盘比赛通过gameId获取题信息
请求参数
参数名称	参数类型	说明
cupId	int	
gameId	int
*/

const gameInfo = apiRegister('game-info', {
    protoId: 888,
    path: '/award/reality/gameinfo/',
    checkQuery(Q) {
        if (!isNumber(Q.cupId) || !isNumber(Q.gameId)) {
            return ERR_REP_GAME_INFO // 参数错误
        }
        return 0
    },
    checkResult,
    formatResult
})


/*
协议Id 
887
项目 
模块 
方式 
https 
命令（路径） 
/award/reality/gameinfoex/
说明
实盘比赛通过交易日获取题信息
请求参数
参数名称	参数类型	说明
cupId	int	
tradingDay	date	交易日
*/

const gameInfoEx = apiRegister('game-info-ex', {
    protoId: 887,
    path: '/award/reality/gameinfoex/',
    checkQuery(Q) {
        const {
            cupId,
            tradingDay
        } = Q
        if (!cupId || !tradingDay || !isNumber(cupId) || !isString(tradingDay)) {
            return ERR_REQ_GAME_ID // 参数错误
        }
        return 0
    },
    checkResult,
    formatResult
})


// 接口
export async function gameLoad({
    cupId,
    gameId,
    tradingDay
}, opts) {
    if (gameId > 0) {
        return gameInfo.send({
            cupId,
            gameId
        }, opts)
    } else if (tradingDay) {
        return gameInfoEx.send({
            cupId,
            tradingDay
        }, opts)
    }
    throw '参数错误'
}
